module.exports = __webpack_public_path__ + "img/503.c678f6a3.jpg";